<template>
  <div style="display: flex">
    <treeselect
      v-model="result"
      :multiple="true"
      :options="options"
      value-consists-of="LEAF_PRIORITY"
    >
    </treeselect>
  </div>
</template>

<script>
export default {
  props: ['filter'],
  data() {
    const today = new Date();
    const startYear = today.getFullYear() - 3;
    const thisYear = today.getFullYear();
    const thisMonth = today.getMonth() + 1;
    let options = [];
    let result = [];
    for (let i = startYear; i <= startYear + 4; i++) {
      let group = {id: i, label: i, children: []};
      for (let j = 1; j <= 12; j++) {
        const formatter = new Intl.DateTimeFormat('en', { month: 'short' });
        let date = Date.parse(i + '-' + j + '-1');
        let option = {
          label: formatter.format(date) + ' ' + i
        };
        if (this.filter.level.levelDbType === 'MONTH1') {
          option.id = this.filter.level.levelId + '.&[' + i + ']&[' + j + ']';
        } else {
          option.id =
            this.filter.level.levelId + '.&[' + i + ('0' + j).slice(-2) + ']';
        }
        group.children.push(option);
        if (i === thisYear && j === thisMonth) {
          result.push(option.id);
        }
      }
      options.push(group);
    }

    return {
      options: options,
      result: result
    };
  },
  mounted() {
    this.UpdateData();
  },
  watch: {
    result() {
      this.UpdateData();
    }
  },
  methods: {
    UpdateData() {
      this.$emit('input', this.result);
    },
    ClearAll() {
      this.result = [];
    }
  }
};
</script>
